import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About Factory',
    href: '#factory'
  }, {
    name: 'Collections',
    href: '#collection'
  }, {
    name: 'Wholesale Pricing',
    href: '#pricing'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const whatsappLink = 'https://api.whatsapp.com/send/?phone=84869812254&text&type=phone_number&app_absent=0';
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-201">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <div className="flex items-center justify-between" data-id="element-203">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-204">
            <img src="https://cdn.magicpatterns.com/uploads/owR9nW8R3mfWdbuvzVE1p4/Logo_don_gian_O.png" alt="Lux Hair Logo" className="h-12 w-auto object-contain" data-id="element-205" />
            <div className="flex flex-col" data-id="element-206">
              <span className="text-xl font-bold leading-none text-[#4B280B]" data-id="element-207">
                LUX HAIR
              </span>
              <span className={`text-[10px] tracking-widest uppercase ${isScrolled ? 'text-gray-500' : 'text-gray-300'}`} data-id="element-208">
                Vietnam Factory
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-209">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-[#7E3007] ${isScrolled ? 'text-gray-700' : 'text-white/90'}`} data-id="element-210">
                {link.name}
              </a>)}
            <Button variant={isScrolled ? 'primary' : 'outline'} size="sm" onClick={() => window.open(whatsappLink, '_blank')} data-id="element-211">
              Get Price List
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-212">
            {isMobileMenuOpen ? <X className={isScrolled ? 'text-gray-900' : 'text-white'} data-id="element-213" /> : <Menu className={isScrolled ? 'text-gray-900' : 'text-white'} data-id="element-214" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100 p-4 flex flex-col gap-4 animate-in slide-in-from-top-5" data-id="element-215">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-800 font-medium py-2 border-b border-gray-50 last:border-0" onClick={() => setIsMobileMenuOpen(false)} data-id="element-216">
              {link.name}
            </a>)}
          <Button className="w-full" onClick={() => {
        setIsMobileMenuOpen(false);
        window.open(whatsappLink, '_blank');
      }} data-id="element-217">
            Get Price List
          </Button>
        </div>}
    </header>;
}